exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".serviceworker-ready-notice-wrapper{position:fixed;z-index:4;top:0;right:0;left:0;display:flex;pointer-events:none}.serviceworker-ready-notice{margin:0 auto;pointer-events:auto}", ""]);

